import { render, staticRenderFns } from "./RatingAdvancedProps.vue?vue&type=template&id=36bee325&scoped=true"
import script from "./RatingAdvancedProps.vue?vue&type=script&lang=js"
export * from "./RatingAdvancedProps.vue?vue&type=script&lang=js"
import style0 from "./RatingAdvancedProps.vue?vue&type=style&index=0&id=36bee325&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bee325",
  null
  
)

export default component.exports